import { useElementMetadata } from "@/components/contexts/ElementMetadataContext";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useActiveProject } from "@/utils/utils";
import type { JsxElement } from "@/utils/jsxElementTypes";

export const useImagePreview = (element: JsxElement) => {
  const { metadata } = useElementMetadata();
  const project = useActiveProject();
  const elementsToFetch = useSelector(
    (state: { metadata: { elementsToFetch: string[] } }) =>
      state.metadata.elementsToFetch
  );

  const { imagePath, metadataStatus } = useMemo(() => {
    const fileHash = element.fileHash;

    const metadataStatus =
      fileHash && elementsToFetch.includes(fileHash) ? "pending" : "done";

    let imagePath: string | null = null;

    // Prioritize previewUrl from elementmetadata table
    if (fileHash && metadata && metadata[fileHash]?.previewUrl) {
      imagePath = metadata[fileHash].previewUrl;
    }

    // Special logic for storybook components
    if (element?.type === "storybook-component") {
      const storyName = element?.filename
        ? element.filename.split("/").pop()
        : undefined;
      const { componentName, library } = element;
      if (library && storyName && componentName) {
        imagePath = `https://storage.googleapis.com/tempo-image-previews/${library}/${storyName}/${componentName}.png`;
      }
    }

    return { imagePath, metadataStatus };
  }, [element, metadata, elementsToFetch, project]);

  return { imagePath, metadataStatus };
};
